import { BadgeTone } from './components/Badge';

export const ORDER_STATUS_TONES: Record<string, BadgeTone> = {
  pending: 'amber',
  confirmed: 'blue',
  processing: 'purple',
  shipped: 'blue',
  delivered: 'green',
  cancelled: 'red',
};

export const QUOTE_STATUS_TONES: Record<string, BadgeTone> = {
  new: 'amber',
  reviewed: 'blue',
  quoted: 'purple',
  accepted: 'green',
  rejected: 'red',
  expired: 'gray',
};

export const ORDER_STATUSES = Object.keys(ORDER_STATUS_TONES);
export const QUOTE_STATUSES = Object.keys(QUOTE_STATUS_TONES);
